module.exports = __webpack_public_path__ + "img/Arif-Medianto@2x.393fe2a2.png";